var map = {
	"./arrow-right.svg": "2552",
	"./back-icon.svg": "723e",
	"./car.svg": "fc0d",
	"./discount.svg": "33a1",
	"./gift.svg": "5673",
	"./home-enter.svg": "5824",
	"./home-exit.svg": "8a08",
	"./info.svg": "b4ae",
	"./location-icon.svg": "69a5",
	"./mail-icon.svg": "ec1d",
	"./new-card.svg": "26ed",
	"./phone-icon.svg": "1593",
	"./search-icon.svg": "6563",
	"./user.svg": "e7f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a79d";